import React from 'react';
// import icon1 from '../../icons/icon_dollar_2.svg';
// import icon2 from '../../icons/icon_bank_building.svg';
import icon3 from '../../icons/icon_scan.svg';
import icon4 from '../../icons/icon_pinpoint.svg';
import icon5 from '../../icons/icon_bank_building.svg';
import shape1 from '../../images/shapes/shape_section_divider_1.svg';
import sImg from '../../images/site_logo/flipcoin.png';
import shape2 from '../../images/shapes/shape_poligon.svg';


const services = [
  // {
  //   icon: icon1,
  //   title: 'Universal ATM',
  //   description: 'Attract more customers with a reward system they understand',
  //   delay: 200,
  // },
  // {
  //   icon: icon2,
  //   title: 'Smart Banking Branch',
  //   description: 'Encourage repeat purchases through milestone-based wallet rewards',
  //   delay: 300,
  // },
  {
    icon: icon3,
    title: '100% Transparent',
    description: 'Gain visibility through the broader TopCoin UK network',
    delay: 400,
  },
  {
    icon: icon4,
    title: 'Not an Investment ',
    description: 'Offer more value than competitors with no extra cost to the customer',
    delay: 500,
  },
    {
    icon: icon5,
    title: ' Reward Guaranteed',
    description: 'Be part of the latest marketing innovation using blockchain-inspired systems',
    delay: 600,
  },
  
];

const ChooseSection = () => {
  return (
    <section id="id_ico_service_section" className="ico_service_section section_space pb-4 section_decoration section_shadow_top">
      <div className="decoration_item shape_divider_1">
        <img src={shape1} alt="Shape Divider" />
      </div>

      <div className="container">
        <div className="ico_heading_block text-center mt-lg-4" data-aos="fade-up" data-aos-duration="600">
          <h2 className="heading_text mb-0">Why join TopCoin UK?</h2>
        </div>

        <div className="row m-lg-0 justify-content-center">
          <div className="col-lg-4 p-lg-0" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
            <div className="ico_service_image text-center">
              <img src={sImg} alt="ICO Service Icon" />
            </div>
          </div>
          {services.map((service, index) => (
            <div key={index} className={`col-lg-4 ${index === 0 ? 'order-lg-first' : ''}`} data-aos="fade-up" data-aos-duration="600" data-aos-delay={service.delay}>
              <div className="ico_iconbox_block text-center">
                <div className="iconbox_icon">
                  <img src={service.icon} alt={service.title} />
                </div>
                <div className="iconbox_info">
                  <h3 className="iconbox_title">{service.title}</h3>
                  {/* <p className="iconbox_description mb-0">{service.description}</p> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="decoration_item shape_shadow_1">
        <img src={shape2} alt="Shape Color Shadow" />
      </div>
      <div className="decoration_item shape_shadow_2">
        <img src={shape2} alt="Shape Color Shadow" />
      </div>
    </section>
  );
};

export default ChooseSection;
